import { SET_PLANT_DETAILS, GET_GEN_CAPACITY_ALL, SET_CONSUMER_DETAILS, GET_GEN_CAPACITY_EDIT_HISTORY, RESET_GEN_CAPACITY } from './types';

const initialState = {
}

const capacityReducer = (state = initialState, action) => {
    if (action.type) {
        switch (action.type) {
            case SET_PLANT_DETAILS:
                return {
                    ...state,
                    ...action.payload
                }
            case GET_GEN_CAPACITY_ALL:
                return {
                    ...state,
                    allGenCapacity: action.payload
                }
            case GET_GEN_CAPACITY_EDIT_HISTORY:
                return {
                    ...state,
                    genCapacityEditHistory: action.payload
                }
            case RESET_GEN_CAPACITY:
                return initialState;
            default:
                {
                    return state;
                }
        }
    }
}

export default capacityReducer;